<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row class="justify-content-md-center">
        <b-col md="7" sm="12" class="mt-2">
          <p class="reg-heading-tab">Add Family Member Details</p>
          <p></p>
          <div class="reg-tab-container">
            <b-form-group
              id="InputGroup1"
              horizontal
              label="Full Name of Family Member *"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                type="text"
                placeholder="Family Member Name"
                size="sm"
                :formatter="format"
                lazy-formatter
                required
                v-model="form.UserFamily.FullName"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="InputGroup2"
              horizontal
              label="Gender *"
              label-size="sm"
              label-for="Input2"
            >
              <b-form-radio-group
                id="radiosn1"
                v-model="form.UserFamily.Gender"
                name="radioNomineeGender"
              >
                <b-form-radio value="1">Male</b-form-radio>
                <b-form-radio value="0">Female</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <!-- <b-form-group id="InputGroup3" horizontal
                            label="Birth Date *" label-size="sm"
                            label-for="Input3">
                        <date-picker v-model="DOB" :not-after="currentDate" format="DD-MM-YYYY" lang="en" required size="small"></date-picker>
            </b-form-group>-->
            <b-form-group
              id="InputGroup3"
              horizontal
              label="Age (Yrs) *"
              label-size="sm"
              label-for="Input3"
            >
              <b-form-input
                type="number"
                placeholder="Family Member Age"
                size="sm"
                required
                v-model="form.UserFamily.Age"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="InputGroup2"
              horizontal
              label-size="sm"
              label="Relationship *"
              required
              label-for="Input2"
            >
              <b-form-select
                id="Input1"
                :options="relations"
                required
                size="sm"
                value-field="RelationshipID"
                text-field="RelationshipName"
                v-model="form.UserFamily.ReletionShipID"
              ></b-form-select>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2 justify-content-md-center" v-if="!LockProfile">
        <b-col md="4" sm="12" style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col md="4" sm="12" style="text-align:right" class="button-wrap">
          <b-button type="submit" variant="primary">Add to List</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>
    <div class="mt-2 reg-details-wrap">
      <p class="reg-heading-tab">Family Details</p>
      <b-row align-h="center">
        <b-col>
          <b-table
            show-empty
            head-variant="dark"
            stacked="md"
            bordered
            striped
            :items="familyMembers"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            style="font-size:12px"
          >
            <!-- <template slot="Gender" slot-scope="data">{{data.value?'Male':'Female'}}</template> -->
            <template v-slot:cell(Gender)="data">{{data.value?'Male':'Female'}}</template>
            <template v-slot:cell(show_details)="row">
              <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
              <b-button
                size="sm"
                @click.stop="row.toggleDetails"
                variant="link"
                class="m-0"
              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
                size="sm"
                @click.stop="editMember(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="outline-success"
                v-b-tooltip.hover
                title="Edit Member"
                v-if="!LockProfile"
              >
                <i class="fa fa-edit" style="font-size:16px;color:blue"></i>
              </b-button>
              <b-button
                size="sm"
                @click.stop="deleteMember(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="outline-danger"
                v-b-tooltip.hover
                title="Delete Member"
                v-if="!LockProfile"
              >
                <i class="fa fa-trash" style="font-size:16px;color:red"></i>
              </b-button>
            </template>
            <!-- <template slot="row-details" slot-scope="row">
                                <b-card>
                                    <span>{{row.item.description}}</span>
                                </b-card>
            </template>-->
          </b-table>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="showModal" title="Are you sure?" size="sm" hide-header-close>
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import * as _ from "lodash";
var _currentDate = new Date();
export default {
  name: "FamilyDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      relations: [
        { RelationshipID: 1, RelationshipName: "Father" },
        { RelationshipID: 2, RelationshipName: "Mother" },
        { RelationshipID: 3, RelationshipName: "Spouse" },
        { RelationshipID: 5, RelationshipName: "Son" },
        { RelationshipID: 4, RelationshipName: "Daughter" },
        { RelationshipID: 6, RelationshipName: "Brother" },
        { RelationshipID: 7, RelationshipName: "Sister" },
        { RelationshipID: 8, RelationshipName: "Other" }
      ],
      DOB: null,
      currentDate: _currentDate,
      form: {
        UserFamily: {
          FullName: "",
          Gender: 1,
          ReletionShipID: 0,
          FamilyID: "00000000-0000-0000-0000-000000000000",
          UserID: "00000000-0000-0000-0000-000000000000",
          Age: 0
        },
        LoginID: "00000000-0000-0000-0000-000000000000"
      },
      familyMembers: [],
      fields: [
        { key: "FullName", label: "Family Member Name", sortable: true },
        { key: "Gender", label: "Gender", sortable: true },
        // {
        //   key: "DOB",
        //   label: "Birth Date",
        //   formatter: "convertDateFormat",
        //   sortable: true
        // },
        { key: "Age", label: "Age", sortable: true },
        { key: "ReletionshipName", label: "Relation", sortable: true },
        { key: "actions", label: "Edit" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedNomineeId: "",
      saved: false,
      showModal: false
    };
  },
  computed: {
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    }
  },
  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      var userinfo = this.$store.getters.loggedUser;

      let _member = _.filter(this.familyMembers, {
        FullName: this.form.UserFamily.FullName
      });

      if (_member.length > 0) {
        if (_member[0].FamilyID != this.form.UserFamily.FamilyID) {
          this.alertText = "Member Already Added to the list";
          this.variant = "warning";
          this.showDismissibleAlert = true;
          this.isLoading = false;
          return;
        }
      }

      if (this.form.UserFamily.Gender == "0" || this.form.UserFamily.Gender == 0) {
        this.form.UserFamily.Gender = false;
      } else {
        this.form.UserFamily.Gender = true;
      }

      this.form.LoginID = userinfo.UserId;
      this.form.UserFamily.UserID = userinfo.UserId;
      //this.form.UserFamily.DOB = Formatter.convertDateFormatYMD(this.DOB);
      let promise = apis.saveFamilyMember(this.form.UserFamily);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.getFamilyMembers();
            this.onReset();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error while Saving Data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form.UserFamily = {
        FullName: "",
        Gender: 1,
        ReletionShipID: 0,
        FamilyID: "00000000-0000-0000-0000-000000000000",
        UserID: "00000000-0000-0000-0000-000000000000",
        Age: 0
      };
    },
    editMember(item, index, target) {
      this.form.UserFamily.FamilyID = item.FamilyID;
      this.form.UserFamily.FullName = item.FullName;
      this.form.UserFamily.Gender = item.Gender ? 1 : 0;
      //this.form.UserFamily.DOB = item.DOB.split("T")[0];
      this.form.UserFamily.ReletionShipID = item.ReletionShipID;
      //this.DOB = item.DOB;
      this.form.UserFamily.Age = item.Age;
    },
    getFamilyMembers() {
      var userinfo = this.$store.getters.loggedUser;
      let promise = apis.ReadFamilyMembers(userinfo.UserId);

      promise
        .then(response => {
          //console.log('Nominee Reponse' ,response);
          if (response.status == 200) {
            this.familyMembers = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message || "Error while getting the details";
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    //Delte Family Member post confirmation

    deleteMember(item, index, button) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.UserFamily.FamilyID = item.FamilyID;
      this.form.UserFamily.FullName = item.FullName;
      this.form.UserFamily.Gender = item.Gender ? 1 : 0;
      //this.form.UserFamily.DOB = item.DOB.split("T")[0];
      this.form.UserFamily.ReletionShipID = item.ReletionShipID;
      this.form.UserFamily.UserID = userinfo.UserId;
      this.form.Age = item.Age;

      let info = "You want to delete record for:" + "\n" + item.FullName;
      this.modalInfo = info;
      this.showModal = true;
    },
    modalCancel() {
      this.onReset();
      this.showModal = false;
    },

    modalConfirm() {
      //let promise = apis.deleteFamilyMember(this.form);
      let promise = apis.deleteFamilyMember(this.form.UserFamily);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            this.onReset();
            this.getFamilyMembers();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.showModal = false;
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.getFamilyMembers();
    }

    let promise = apis.ReadRelations();

    promise
      .then(response => {
        //console.log('Nominee Reponse' ,response);
        if (response.status == 200) {
          this.relations = response.body;
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/Family.vue